import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { applyBrand } from '@pos/shared';
import { neutralBrand } from '@pos/tokens';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';

import { store } from '@/app/store';
import { DialogHost } from '@/app/DialogHost';
import { router } from '@/routes';
import { ToastHost } from '@/shared/toast';

import '@/shared/styles/global.css';

// The tab title and favicon, from the token package rather than the static HTML. Neutral at
// boot: the access token is memory-only, so a cold load is always signed out and the till serves
// every shop. `PosShell` re-stamps it with the shop's name once there is one.
applyBrand(neutralBrand.pos);

const container = document.getElementById('root');

if (container === null) {
  throw new Error('The #root element is missing from index.html — the app has nowhere to mount.');
}

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
      {/* Outside the router on purpose: a dialog or a toast must survive a navigation, and the
          revoked-session handler fires from the base query with no route in scope. */}
      <DialogHost />
      <ToastHost />
    </Provider>
  </StrictMode>,
);
